;(function($) {
  $(function() {

    $('.video-control-button').on('click',function(e) {
      // console.log('click',e);
      let $this = $(this);
      let label = $this.attr('aria-label');
      if (label === 'play') {
        $this.attr('aria-label','pause');
        $this.parent().siblings('video').trigger('play');
      } else {
        $this.attr('aria-label','play');
        $this.parent().siblings('video').trigger('pause');
      }
    });
    
    const loadVideo = function($video) {
      $('.fallback-image').css({'display':'none'});
      const videoSourceElements = $video.find('source');
      videoSourceElements.each(function(index, vidSourceElement) {
        const $vidSourceJQ = $(vidSourceElement);
        const srcUrl = $vidSourceJQ.attr('data-src'); 
        const smallVidSrcUrl =  $vidSourceJQ.attr('data-src-small');
        if ((window.screenSize == 'narrow') && (smallVidSrcUrl !== undefined)) {
          // load the smaller video on smaller devices
          $vidSourceJQ.attr('src', smallVidSrcUrl);
          $video.attr('width',$video.attr('data-small-width'));
          $video.attr('height',$video.attr('data-small-height'));
        } else {
          // load the full size video
          $vidSourceJQ.attr('src', srcUrl);
        }
        $video[0].load();
      });
      $video.css({
        'height' : '100%',
        'width' : '100%'
      });
      $('.video-control-button-container').css({'display':'block'});
    };
    
    if (navigator.connection && !!navigator.connection.effectiveType) {
      if (navigator.connection.effectiveType === '4g') {
        loadVideo($('.hero-background-video'));  
      } else {
        // too slow for video
        console.log('Slow connection...');
        $('.fallback-image').css({'opacity': '1'});
      }
    } else {
      console.log('Navigator API not supported...');
      loadVideo($('.hero-background-video'));  
    }

    
  });
})(jQuery)